import React, {Component} from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import * as customerActions from '../actions/Customer';
import {openCompanyPickerModal} from '../actions/Modal';
import {changePageToStartPage} from '../actions/Page';
import Title from '../components/base/Title/Title';
import textTranslates from '../components/Customer/translate.json';
import CustomerType from '../components/Customer/CustomerType';
import CustomerCompany from '../components/Customer/CustomerCompany';
import CustomerForm from '../components/Customer/CustomerForm';
import NextBackButton from '../components/Buttons/NextBackButton';
import RodoClause from '../components/RodoClause/RodoClause';
import {getComplaintsTypesDictionary} from '../actions/Util';
import { changeComplaintType } from '../../src/actions/Complaint';

class Customer extends Component {

    onNextWindowButtonClick = () => {
        this.props.approveCustomer();
    }
    onBackButtonClick = () => {
        this.props.changePageToStartPage();
    }

    // onCustomerTypeRadioClick = (customerType) => {
    //     this.props.changeCustomerType(customerType);
    //     this.props.getComplaintsTypesDictionary(customerType.id);
    // }
    
    onEditCompanyButtonClick = () => this.props.openCompanyPickerModal();
    onCustomerBuildingNumberChanged = (e) => this.props.changeBuildingNumber(e.target.value);
    onCustomerCityChanged = (e) => this.props.changeCity(e.target.value);
    onCustomerEmailChanged = (e) => this.props.changeEmail(e.target.value);
    onCustomerFlatNumberChanged = (e) => this.props.changeFlatNumber(e.target.value);
    onCustomerNameChanged = (e) => this.props.changeName(e.target.value);
    onCustomerSurnameChanged = (e) => this.props.changeSurname(e.target.value);
    onCustomerPhoneChanged = (e) => this.props.changePhone(e.target.value);
    onCustomerPostalCodeChanged = (e) => this.props.changePostalCode(e.target.value);
    onCustomerStreetChanged = (e) => this.props.changeStreet(e.target.value);
    onCompanyTaxChanged = (e) => this.props.changeCompanyTax(e.target.value);
    onCompanyNameChanged = (e) => this.props.changeCompanyName(e.target.value);
    onNewCustomerChange = () => this.props.changeNewCustomer();
    onCustomerPhoneCodeChanged = (e) => this.props.changePhoneCode(e.target.value);

    render() {
        return(
            <div className="col-xs-12"> 
                <Title
                    title={textTranslates.customerIndividualComplaint}
                    id="customerTitle"
                    large/>
                {/* <CustomerType
                    customerTypes={this.props.customerTypes}
                    customerType={this.props.customer.type}
                    onRadioClick={this.onCustomerTypeRadioClick}/> */}
                <CustomerCompany
                    customerType={this.props.customer.type.value}
                    companyName={this.props.customer.companyName}
                    companyTax={this.props.customer.companyTax}
                    isMyCompanyNotFoundCheckBoxVisible={this.props.isMyCompanyNotFoundCheckBoxVisible}
                    newCustomer={this.props.customer.newCustomer}
                    onCompanyTaxChanged={this.onCompanyTaxChanged}
                    onCompanyNameChanged={this.onCompanyNameChanged}
                    onEditCompanyButtonClick={this.onEditCompanyButtonClick}
                    onNewCustomerChange={this.onNewCustomerChange} />
                <CustomerForm
                    customer={this.props.customer}
                    onCustomerBuildingNumberChanged={this.onCustomerBuildingNumberChanged}
                    onCustomerCityChanged={this.onCustomerCityChanged}
                    onCustomerEmailChanged={this.onCustomerEmailChanged}
                    onCustomerFlatNumberChanged={this.onCustomerFlatNumberChanged}
                    onCustomerNameChanged={this.onCustomerNameChanged}
                    onCustomerSurnameChanged={this.onCustomerSurnameChanged}
                    onCustomerPhoneChanged={this.onCustomerPhoneChanged}
                    onCustomerPhoneCodeChanged={this.onCustomerPhoneCodeChanged}
                    onCustomerPostalCodeChanged={this.onCustomerPostalCodeChanged}
                    onCustomerStreetChanged={this.onCustomerStreetChanged} />
                <RodoClause />
                <NextBackButton
                    onBackButtonClick={this.onBackButtonClick}
                    onNextButtonClick={this.onNextWindowButtonClick} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    customerTypes: state.util.customerTypes,
    customer: state.customer,
    complaintType:state.complaint.complaintType,
    isMyCompanyNotFoundCheckBoxVisible:state.util.isMyCompanyNotFoundCheckBoxVisible
});
  
const mapDispatchToProps = dispatch => ({
    approveCustomer: () => dispatch(customerActions.validateCustomer()),
    changePageToStartPage: () => dispatch(changePageToStartPage()),
    changeCustomerType: (selectedType) => dispatch(customerActions.changeType(selectedType)),
    changeBuildingNumber: (buildingNumber) => dispatch(customerActions.changeBuildingNumber(buildingNumber)),
    changeCity: (city) => dispatch(customerActions.changeCity(city)),
    changeEmail: (email) => dispatch(customerActions.changeEmail(email)),
    changeFlatNumber: (flatNumber) => dispatch(customerActions.changeFlatNumber(flatNumber)),
    changeName: (name) => dispatch(customerActions.changeName(name)),
    changeSurname: (surname) => dispatch(customerActions.changeSurname(surname)),
    changePhone: (phone) => dispatch(customerActions.changePhone(phone)),
    changePhoneCode:(phoneCode) => dispatch(customerActions.changePhoneCode(phoneCode)),
    changePostalCode: (postalCode) => dispatch(customerActions.changePostalCode(postalCode)),
    changeStreet: (street) => dispatch(customerActions.changeStreet(street)),
    changeCompanyTax: (tax) => dispatch(customerActions.changeTax(tax)),
    changeNewCustomer: () => dispatch(customerActions.changeNewCustomer()),
    changeCompanyName: (companyName) => dispatch(customerActions.changeCompanyName(companyName)),
    getComplaintsTypesDictionary:(customerTypeId) => dispatch(getComplaintsTypesDictionary(customerTypeId)),
    openCompanyPickerModal: () => dispatch(openCompanyPickerModal()),
    changeComplaintType: (complaintType) => dispatch(changeComplaintType(complaintType)),
});

Customer.propTypes = {
    isMyCompanyNotFoundCheckBoxVisible:PropTypes.bool,
    changeCustomerType: PropTypes.func,
    approveCustomer: PropTypes.func,
    customerType: PropTypes.string,
    customerTypes: PropTypes.array,
    openCompanyPickerModal: PropTypes.func,
    customer: PropTypes.shape({
        companyTax: PropTypes.string,
        companyName: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        buildingNumber: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        newCustomer: PropTypes.bool,
        flatNumber: PropTypes.string,
        postalCode: PropTypes.string,
        street: PropTypes.string,
        type: PropTypes.shape({
            displayName: PropTypes.string,
            value: PropTypes.string
        })
    }),
    changeBuildingNumber: PropTypes.func,
    changeCity: PropTypes.func,
    changeEmail: PropTypes.func,
    changeFlatNumber: PropTypes.func,
    changeName: PropTypes.func,
    changeSurname:PropTypes.func,
    changePhone: PropTypes.func,
    changePhoneCode:PropTypes.func,
    changePostalCode: PropTypes.func,
    changeStreet: PropTypes.func,
    changePageToStartPage: PropTypes.func,
    changeCompanyTax: PropTypes.func,
    changeCompanyName: PropTypes.func,
    changeNewCustomer: PropTypes.func,
    getComplaintsTypesDictionary:PropTypes.func
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Customer));


// WEBPACK FOOTER //
// ./src/containers/Customer.js